// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"c8018431","213":"8b0d2d71","239":"7f885ab9","350":"2db42347","430":"b5070467","732":"991f101e","762":"bda4f0e6","794":"5ea0bcc0","852":"e46e9d4f"}[chunkId] + ".chunk.js";
};